import { createContext } from 'react';

import type { RbacSnapshot } from '@/lib/rbac';

export interface AuthState {
    id: number | string;
    name: string;
    businessName: string;
    username: string;
}

export interface TokenPair {
    access: string;
    refresh: string;
}

export interface UserData {
    id: number;
    uuid: string;
    email: string;
    owner_full_name: string;
    username?: string;
    business_name?: string;
    profile_image?: string | null;
    phone_number?: string;
    is_active?: boolean;
}

const AuthContext = createContext<{
    state: AuthState | undefined;
    setState:(value: AuthState | undefined) => void;
    rbac: RbacSnapshot | null;
    setRbac: (value: RbacSnapshot | null) => void;
    refreshRbac: () => Promise<void>;
    logout: () => void;
    login: (tokens: TokenPair, user: UserData, rememberMe?: boolean) => void;
        }>({
            state: undefined,
            setState: () => {
                console.warn('AuthContext.setState called without a provider');
            },
            rbac: null,
            setRbac: () => {
                console.warn('AuthContext.setRbac called without a provider');
            },
            refreshRbac: async () => {
                console.warn('AuthContext.refreshRbac called without a provider');
            },
            logout: () => {
                console.warn('Logout called without a provider');
            },
            login: () => {
                console.warn('Login called without a provider');
            },
        });

export default AuthContext;
